<template>
  <div id="assets">
    <!-- navbar on top of page -->

    <nav class="navbar navbar-expand-lg navbar-dark topbar">
      <a class="navbar-brand" href="home">
        <img
          src="../assets/img/iLogDPI.png"
          style="float:left;width:80px;height:40px;"
        />
      </a>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item">
            <a class="nav-link active" href="home"
              >Dashboard
              <span class="sr-only">(current)</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="users">Users</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="assets">
              Assets
            </a>
          </li>
        </ul>
        <form class="form-inline my-2 my-lg-0">
          <input
            class="form-control mr-sm-2"
            type="search"
            placeholder="Search..."
            aria-label="Search"
            v-model="search"
          />
        </form>
      </div>
      <div v-if="role == 'management'">
        <button
          class="btn btn-outline-success"
          style="margin:5px;"
          data-toggle="modal"
          data-target="#addNewAssetBox"
          @click="
            ;(checkform = false), (hostname = null), (customerName = null)
          "
        >
          Add Asset
        </button>
      </div>
      <button class="btn btn-outline-danger" @click="logout">Logout</button>
    </nav>

    <!-- <br />
    <br />
    <br />
    <div class="text_hd">Welcome: {{ this.username }}</div>
    <img
      class="icon-header"
      src="../assets/img/DPI-box.png"
      width="500px"
      height="400px"
    />

    <br />
    <br />

    <button
      class="btn btn-success"
      style="margin:5px;"
      @click.prevent="relocate_dpiguide()"
    >
      คู่มือการใช้งาน iLog-DPI
    </button>
    <br />
    <button class="btn btn-primary" @click="relocate_users()">
      จัดการบัญชีผู้ใช้ คลิกที่นี่
    </button>
    <button
      class="btn btn-primary"
      style="margin:5px;"
      @click="relocate_assets()"
    >
      จัดการโฮสต์ คลิกที่นี่
    </button> -->
    <!-- <lottie-player
          src="https://assets2.lottiefiles.com/datafiles/riuf5c21sUZ05w6/data.json"
          background="transparent"
          speed="1"
          style="width: 100%; height: 300px; "
          loop
          autoplay
        ></lottie-player> -->
  </div>
</template>

<script>
import jwtDecode from 'jwt-decode'
import firebase from 'firebase/app'
import '@firebase/auth'
import '@firebase/database'
import '@firebase/analytics'

export default {
  name: 'home',
  data() {
    return {
      username: '',
    }
  },
  created() {
    this.token = sessionStorage.getItem('user-token')
    this.decoded = jwtDecode(this.token)
    this.username = this.decoded.username
  },

  methods: {
    relocate_dpiguide() {
      window.open('https://app.gitbook.com/@ilog-ai/s/dpi/', '_blank')
    },
    relocate_users() {
      window.location.href = 'users'
    },
    relocate_assets() {
      window.location.href = 'assets'
    },
    relocate_cpu() {
      window.location.href = 'Dashboard'
    },
    logout() {
      firebase
        .auth()
        .signOut()
        .then(function() {
          // Sign-out successful.
        })
      sessionStorage.removeItem('user-token')
      this.$router.push({
        name: 'login',
      })
    },
  },
  async mounted() {
    await await firebase
      .auth()
      .signInWithEmailAndPassword(
        'ilogdpi@dpi.co.th',
        'UbseX+MnUbu=7x#A@VtGeYmwrrBFzq'
      )
    await this.relocate_cpu()
  },
}
</script>

<style>
.text_hd {
  color: white;
}
</style>
